import {Module} from 'vuex'
import {RootState} from '@/store/types'
import Category from '@/modules/support/model/Category'
import actions from '@/modules/support/store/actions'
import mutations from '@/modules/support/store/mutations'
import Pagination, {PaginationInput} from '@/modules/core/model/pagination';
import Guide from '@/modules/support/model/Guide';
import {GuideListFilters, GuideViewListFilters} from '@/modules/support/api';
import Step from '@/modules/support/model/Step';
import GuideView from '@/modules/support/model/GuideView';
import {Screen} from "@/modules/support/model/Screen";

export interface SupportModuleState {
    /**
     * Categoría raíz
     */
    rootCategory: Category

    /**
     * Categoría actualmente en edición por el usuario
     */
    currentCategory: Category | null

    /**
     * Paginación de guías actualmente mostrada al usuario
     */
    guidePagination: Pagination<Guide>

    /**
     * Opciones para la paginación de guías
     */
    guidePaginationInput: PaginationInput<GuideListFilters>

    /**
     * Guía actualmente selecciona por el usuario
     */
    currentGuide: Guide

    /**
     * Paso actualmente seleccionado por el usuario
     */
    currentStep: Step,

    /**
     * Paginación de visitas a guías
     */
    guideViewPagination: Pagination<GuideView>

    /**
     * Parámetros para la paginación de visitas
     */
    guideViewPaginationInput: PaginationInput<GuideViewListFilters>

    /**
     * Categoría a la cual serán movidas las guías de la categoría que está siendo eliminada
     */
    replacementCategory: Category | null,

    /**
     * Lista de pantallas
     */
    screens: Screen[]
}

const module: Module<SupportModuleState, RootState> = {
    namespaced: true,
    mutations,
    actions,
    state: {
        rootCategory: new Category(),
        currentCategory: null,
        replacementCategory: null,
        guidePagination: {
            totalPages: 0,
            totalRecords: 0,
            items: [],
        },
        guidePaginationInput: {
            page: 1,
            recordsPerPage: 50,
            filters: {},
        },
        currentGuide: new Guide(),
        currentStep: new Step(),
        guideViewPagination: {
            totalPages: 0,
            totalRecords: 0,
            items: [],
        },
        guideViewPaginationInput: {
            page: 1,
            recordsPerPage: 50,
            filters: {},
        },
        screens: [],
    },
}

export default module
